export const getGridSize = (count: number): number => {
    switch (count) {
        case 1:
            return 12
        case 2:
            return 6
        default:
            return 4
    }
}
